import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ verified, size = 4, className = "" }) {
  if (!verified) return null;
  const cls = size === 5 ? "w-5 h-5" : size === 3 ? "w-3 h-3" : "w-4 h-4";
  return (
    <span
      data-testid="verified-badge"
      title="Verified seller"
      className={`inline-flex items-center gap-1 text-primary ${className}`}
    >
      <BadgeCheck className={`${cls} fill-primary text-primary-foreground`} strokeWidth={2}/>
    </span>
  );
}
